export default __webpack_public_path__ + "static/quote-9-03fe60835f398627afb2df27be9f7637.mp3";